import {Optional} from 'data/types'
import moment from 'moment'
import Cookies from 'universal-cookie'

export interface IAuthTokenProvider {
  getAuthToken(): Optional<string>
  storeAuthToken(jwt: string): void
  removeAuthToken(): void
}

export class CookieAuthTokenProvider implements IAuthTokenProvider {
  private cookies = new Cookies()
  private authTokenKey = 'ITX_AUTH_TOKEN'

  public getAuthToken = () => this.cookies.get(this.authTokenKey) ?? ''
  public removeAuthToken = () => {
    this.cookies.remove(this.authTokenKey, {path: '/'})
  }

  public storeAuthToken = (jwt: string) => {
    this.cookies.set(this.authTokenKey, jwt, {
      expires: moment().add(5, 'days').toDate(),
      path: '/',
    })
  }
}

export class StaticTokenProvider implements IAuthTokenProvider {
  private authToken: string

  public constructor(authToken: string) {
    this.authToken = authToken
  }

  public getAuthToken = () => {
    return this.authToken
  }

  public removeAuthToken = () => {
    // no-op
  }

  public storeAuthToken = () => {
    // no-op
  }
}
